import React, { CSSProperties, FC } from 'react';
import { styled } from '@material-ui/core/styles';

const StyledQuestion = styled('h2')(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 'bold',
  textAlign: 'center',
  color: '#4A4A4A',
  fontSize: '30px',
  lineHeight: '36px',
  margin: 0,
  marginBottom: 20,

  [theme.breakpoints.up('sm')]: {
    fontSize: '40px',
    lineHeight: '48px',
    marginBottom: 25,
  },
}));

interface Props {
  label: string;
  style?: CSSProperties;
}

const Question: FC<Props> = ({ label, style }) => {
  return <StyledQuestion style={style}>{label}</StyledQuestion>;
};

export default Question;
